import { SENSITIVE_DATA_ROW_COPY_FIELD_KEY_BY_TYPE } from "constants/sensitiveData";
import { SensitiveDataResponse } from "apis/sensitiveData";
import { SensitiveDataFormField } from "types/Models/sensitiveData";
import { getSensitiveDataPrimaryField } from "util/getSensitiveDataPrimaryField";

export const getSensitiveDataRowCopyField = (
  record: SensitiveDataResponse
): SensitiveDataFormField | undefined => {
  const fieldKey =
    SENSITIVE_DATA_ROW_COPY_FIELD_KEY_BY_TYPE[record.sensitive_data_type];

  const namedField = record.form_data?.find(
    (field) => field.field_key === fieldKey
  );

  if (namedField?.is_copyable) return namedField;

  const primaryField = getSensitiveDataPrimaryField(record.form_data);

  if (primaryField?.is_copyable) return primaryField;

  return undefined;
};
